export const Checkcolor = (id : any, data?: any) => {
    let tempColor: string = ""
    
    tempColor = data?.priorListDropdown?.find((item: any) => item.Id === id)?.Color

    return tempColor
    // return `text-[${tempColor}] drop-shadow-lg`
}
